import { HWC_MAIN_URL } from "constants/server/api";
import join from "url-join";
export function getFullUrlPath(filePath) {
    var isFile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var fullUrl = filePath;
    var isAbsoluteURLRegex = /^(?:\w+:)\/\//;
    if (!isAbsoluteURLRegex.test(filePath)) {
        fullUrl = join(isFile ? HWC_MAIN_URL : "".concat(HWC_MAIN_URL, "/cdn-cgi/image/quality=100"), filePath);
    }
    return fullUrl;
}
export function getFileName(url) {
    var name = url.split("/").pop().split("?")[0].split("#")[0];
    return name;
}
